<template>
    <section class="channelList">
        <van-nav-bar title="渠道管理" left-arrow class="top_bar" @click-left="onClickNavLeft" right-text="添加渠道" @click-right="onClickNavRight">
        </van-nav-bar>
        <van-loading v-if="isLoading" size="24px" vertical style="margin-top: 120px;">加载中...</van-loading>
        <section v-if="!isLoading" class="card_list" v-for="channel in list" :key="channel.id">
            <div class="card">
                <div class="item">
                    <div class="label"><p>渠道名称</p></div>
                    <div class="info"><p>{{channel.channelName}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>渠道评级</p></div>
                    <div class="info"><p>{{channel.channelRating | f_channelRating}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>创建人员</p></div>
                    <div class="info"><p>{{channel.creatorName || '-'}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>创建时间</p></div>
                    <div class="info"><p>{{channel.gmtCreate}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>更新时间</p></div>
                    <div class="info"><p>{{channel.gmtModify}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>备注</p></div>
                    <div class="info"><p>{{channel.remark}}</p></div>
                </div>
            </div>                   
        </section>
        <section v-if="!isLoading && !list.length" class="nodata_class">
            <div class="no_data">
                <img src="../../../assets/img/customer_default.png" />
                <p>暂无记录</p>
            </div>
        </section>
        <van-popup round v-model="showChannelForm" :style="{ width: '80%' }">
            <van-form @submit="onSubmitForm">
                <van-field
                    v-model="channelForm.channelName"
                    name="channelName"
                    label="渠道名称"
                    placeholder="请填写渠道名称"
                    type="text"
                    required
                    :rules="[
                        { required: true, message: '请填写渠道名称，2到8个字' },
                        { pattern: teamNameRe, message: '渠道名称在2到8个字' },
                    ]"
                />

                <van-field name="channelRating" label="渠道级别" :rules="[{ required: true, message: '请选择渠道级别' }]" required>
                    <template #input>
                        <van-radio-group v-model="channelForm.channelRating" direction="horizontal">
                            <van-radio v-for="item in channelRatingList" :name="item.value" :key="item.vaule">{{item.text}}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>


                <van-field
                    v-model="channelForm.remark"
                    name="remark"
                    label="备注"
                    placeholder="请填写备注"
                    type="textarea"
                    rows="2"
                    autosize
                    maxlength="50"
                    show-word-limit
                />

                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </van-popup>
	</section>
</template>

<script>
import Nav from "components/Nav"
import settingServer from "api/setting";
import { Toast } from "vant";

export default {
    name: "channelList",
    components: {
		Nav,
	},
    data() {
        return {
            isLoading: true,

            list: {},
            teamNameRe: /^.{2,8}$/,
            channelForm: {
                pricingCoefficient: 1,
            },
            showChannelForm: false,

            channelRatingList: [
                {text: 'A类特级', value:0},
                {text: 'B类优质', value:1},
                {text: 'C类普通', value:2},
            ],
		};
    },    
    created() {
        this.getInfo();
	},
	mounted() {
	},	
    methods: {
        getInfo() {
            this.isLoading = true
            settingServer.getChannelPageList({pageNum: 1, pageSize: 1000}).then((res) => {
                this.list = res.data.list
                this.isLoading = false
            })
        },

        onClickNavLeft() {
            this.$router.go(-1);
        },

        onClickNavRight() {
            this.showChannelForm = true
        },

        onSubmitForm() {
            settingServer.addChannel(this.channelForm).then((res) => {
                this.showChannelForm = false

                Toast('添加渠道成功')
                this.getInfo()

                this.channelForm = {
                    pricingCoefficient: 1,
                }
            })
        }
    },
};
</script>

<style lang="scss">
	.channelList {
        padding-top: 46px;

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .head {
                padding: 16px 30px;
                border-bottom: 1px solid #E9F0F8;

                h3 {
                    color: #303030;
                    font-size: 17px;
                    line-height: 22px;
                    font-weight: 500;
                }
            }

            .item {
                margin-left: 30px;
                padding: 16px 30px 16px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info {
                    max-width: 70%;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                    text-align: right;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .nodata_class {
            background-color: #f8f8f8;
            display: flex;
            align-items: center;
            justify-content: center;

            .no_data {
                position: relative;

                img {
                    width: 252px;
                    display: inline-block;
                }

                p {
                    padding-top: 22px;
                    color: #4d5b80;
                    font-size: 16px;
                    text-align: center;
                }
            }
        }

        .van-form{
            padding: 10px;
        }

        .van-radio {
            margin-bottom: 6px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/channel/Channel.vue